import { Node } from '@tiptap/core';

const Document = Node.create({
    name: 'doc',
    topNode: true,
    content: 'block+',
});

export { Document, Document as default };
//# sourceMappingURL=index.js.map
